import React, { createContext, useContext } from 'react';
import { useGatesNowData } from './hooks/useGatesNowData';

const GatesNowDataContext = createContext(null);

export const GatesNowDataProvider = ({ children }) => {
    const value = useGatesNowData();
    return (
        <GatesNowDataContext.Provider value={value}>
            {children}
        </GatesNowDataContext.Provider>
    );
};

export const useGatesNow = () => {
    const ctx = useContext(GatesNowDataContext);
    if (!ctx) {
        throw new Error('useGatesNow must be used within GatesNowDataProvider');
    }
    return ctx;
};
